'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var EMVReaderIcon = function EMVReaderIcon(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M22.2,1.5H9.6c-1,0-1.8,0.9-1.8,1.9V4H2C0.9,4,0,4.9,0,6l0,12c0,1.1,0.9,2,2,2h5.8v0.6c0,1,0.8,1.9,1.8,1.9h12.6\n\tc1,0,1.8-0.9,1.8-1.9V3.4C24,2.4,23.2,1.5,22.2,1.5z M2,6h5.8v2H2V6z M2,18v-6h5.8v6H2z M15.7,18.4c-3.5-3.5-3.5-9.2,0-12.7l1.2,1.2\n\tc-2.9,2.9-2.9,7.5,0,10.4L15.7,18.4z M19.1,14.9L18,16.1c-2.2-2.2-2.2-5.9,0-8.1l1.2,1.2C17.5,10.7,17.5,13.3,19.1,14.9z"
  }));
};

var EMVReaderIcon$1 = iconStyles()(EMVReaderIcon);

module.exports = EMVReaderIcon$1;
